import './index.css'

const UserInfo = () => (
  <div className="user-info-container">
    <img
      className="profile-img"
      src="https://assets.ccbp.in/frontend/react-js/profile-img.png"
      alt="profile"
    />
    <h1 className="user-name">Wade Warren</h1>
    <p className="user-designation">Software developer at UK</p>
  </div>
)

export default UserInfo
